<ng-template #skeleton>
  <div [ngClass]="type"
       class="app-card-box w-100">
    <div class="d-flex gap-2">
      <ngx-skeleton-loader class="m-none" [theme]="{width: '56px', height: '56px', borderRadius: '10px'}"></ngx-skeleton-loader>
      <div class="w-100 d-flex flex-column ion-justify-content-center gap-2">
        <div class="d-flex ion-justify-content-between align-items-center">
          <ngx-skeleton-loader [theme]="{height: '10px', width: '70px', margin: '0'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{height: '10px', width: '24px', margin: '0'}"></ngx-skeleton-loader>
        </div>
        <ngx-skeleton-loader [theme]="{height: '16px', width: '60%', margin: '0'}"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{height: '10px', width: '40%', margin: '0'}"></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</ng-template>

<div [ngSwitch]="type" style="height: 100%;">
  <ng-container *ngSwitchCase="'vertical'">
    <ng-container *ngTemplateOutlet="vertical"></ng-container>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="chip"></ng-container>
  </ng-container>
</div>


<ng-template #chip>
  <div class="app-card-box w-100"
       *ngIf="!showSkeleton; else skeleton"
       [ngClass]="type"
       [class.no-shadow]="type == 'chip'"
       [class.app-border]="type == 'chip'"
       (click)="onOpenDetail()"
       style="padding: 0;">
    <div class="d-flex gap-4 p-sm">

      <div class="place-image"
           style="position: relative;"
           [appBackgroundImage]="place.img || categoryImage">
      </div>

      <div class="d-flex w-100">

        <div class="d-flex flex-column ion-justify-content-between w-100">


          <div class="d-flex ion-justify-content-between">

            <div class="ts-small-bold text-neutral-500">{{showedCategory?.name | translation}}</div>

          </div>

          <div class="place-name">{{ place.name }}</div>

          <div *ngIf="type != 'horizontal'"
               class="place-address pt-xs">{{ place.address }}</div>

          <div class="d-flex ion-align-items-center ion-justify-content-between">

            <app-distance-place-footer [distance]="place.distance"
                                       [distanceLabel]="place?.distanceLabel">
              <div extraEnd>
                <div class="d-flex ion-align-items-center gap-1">

                </div>

              </div>
            </app-distance-place-footer>

          </div>

        </div>

        <div class="d-flex flex-column ion-justify-content-between">

          <div class="d-flex ion-justify-content-end">
            <app-trackable-items [type]="'place'"
                                 [entity]="place"></app-trackable-items>
          </div>

          <!-- CONTEGGIO EVENTI -->
          <div *ngIf="place?.events?.length > 0"
               style="white-space: pre"
               class="ts-caption text-azzurro-500">+{{place?.events?.length + ' eventi'}}</div>

        </div>

      </div>


    </div>
  </div>
</ng-template>

<ng-template #vertical style="height: 100%;">
  <div class="app-card-box w-100 box-vertical p-none h-100"
       (click)="onOpenDetail()">
    <div class="place-image" [appBackgroundImage]="place.img"></div>

    <div class="p-sm">
      <div class="ts-body-bold four-line text-ellipsis" style="height: var(--title-card-place-image)">{{ place.name }}</div>

      <div class="place-address pt-xs">{{ place.address }}</div>

      <app-distance-place-footer [distance]="place.distance"
                                 [distanceLabel]="place?.distanceLabel"></app-distance-place-footer>
    </div>

  </div>
</ng-template>

<ion-select aria-label="Contatti"
            style="display: none"
            #actions
            (ionChange)="onOpenMap()"
            interface="action-sheet"
            placeholder="Contatti">
  <ion-select-option value="navigate">Vai</ion-select-option>
</ion-select>
